import {Component, computed, effect, ElementRef, inject, model, signal, ViewChild} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {StyleClassModule} from 'primeng/styleclass';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {RippleModule} from 'primeng/ripple';
import {BadgeModule} from 'primeng/badge';
import {OverlayBadgeModule} from 'primeng/overlaybadge';
import {AvatarModule} from 'primeng/avatar';
import {FormsModule} from "@angular/forms";
import { LayoutService } from '../../service/layout.service';
import { SaveableTrackerService } from '../../service/saveable-tracker.service';

interface NotificationsBars {
    id: string;
    label: string;
    badge?: string | any;
}

@Component({
  selector: '[app-topbar]',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    StyleClassModule,
    InputTextModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    RippleModule,
    BadgeModule,
    OverlayBadgeModule,
    AvatarModule,
    ButtonModule,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css'
})
export class TopbarComponent {
  readonly layoutService = inject(LayoutService);
  readonly currentSaveableSignal  = inject(SaveableTrackerService).get();

  readonly isDarkTheme = computed(() => this.layoutService.isDarkTheme());
  readonly isButtonVisible = computed(() => !!this.currentSaveableSignal());
  readonly isDirty = computed(() => this.currentSaveableSignal()?.isDirty?.() ?? false);
  readonly isCancelButtonVisible = computed(() => this.currentSaveableSignal()?.isCancelVisible?.() ?? false);

  @ViewChild('menubutton') menuButton!: ElementRef;

  showRightMenu() {
      this.layoutService.toggleRightMenu();
  }

  onConfigButtonClick() {
      this.layoutService.showConfigSidebar();
  }

  toggleSearchBar() {
      this.layoutService.layoutState.update((value) => ({...value, searchBarActive: !value.searchBarActive}));
  }

  onSaveButtonClick() {
    this.currentSaveableSignal()?.save();
  }

  onCancelButtonClick() {
    this.currentSaveableSignal()?.cancel();
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }
}
